import React from 'react'

export const Center = ({ children }: any) => {
  return <div style={{ textAlign: 'center' }}>{children}</div>
}
